module.exports = __webpack_public_path__ + "static/media/cssnext.b1fc0393.svg";